import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from "@mui/material";
import ReactQuill from "react-quill";

const stripHtml = (html) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};

const EditDialog = ({
  open,
  handleClose,
  initialValue,
  onSave,
  type,
  categoryId,
  title,
}) => {
  const [value, setValue] = useState("");

  const [postTitle, setPostTitle] = useState("");

  useEffect(() => {
    if (open) {

      if (initialValue) {
        if (type === "post") {
          setValue(initialValue);
        } else {
          setValue(stripHtml(initialValue));
        }
      }
      
 
      if (title) {
        setPostTitle(title);
      } else {
        setPostTitle("");
      }
    }
  }, [initialValue, title, type, open]);

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      ["link"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    "image",
  ];

  return (
    <>
      <style jsx global>{`
        /* Toolbar styling */
        .ql-toolbar {
          border-top: 1px solid #ccc !important;
          border-left: 1px solid #ccc !important;
          border-right: 1px solid #ccc !important;
        }

        /* Toolbar buttons and icons */
        .ql-toolbar .ql-stroke {
          fill: none !important;
          stroke: white !important;
        }

        .ql-toolbar .ql-fill {
          fill: white !important;
          stroke: none !important;
        }

        .ql-toolbar .ql-even {
          fill-rule: evenodd !important;
          fill: white !important;
        }

        .ql-toolbar .ql-color-label {
          fill: white !important;
          stroke: white !important;
        }

        /* Dropdown arrows */
        .ql-toolbar .ql-picker-label {
          color: white !important;
        }

        .ql-toolbar .ql-picker-label::before {
          color: white !important;
        }

        /* Active state for toolbar buttons */
        .ql-toolbar button:hover,
        .ql-toolbar button:focus,
        .ql-toolbar button.ql-active {
          color: white !important;
        }

        .ql-toolbar button:hover .ql-stroke,
        .ql-toolbar button:focus .ql-stroke,
        .ql-toolbar button.ql-active .ql-stroke {
          stroke: #06c !important;
        }

        .ql-toolbar button:hover .ql-fill,
        .ql-toolbar button:focus .ql-fill,
        .ql-toolbar button.ql-active .ql-fill {
          fill: #06c !important;
        }

        /* Placeholder text styling */
        .ql-editor.ql-blank::before {
          color: white !important;
          opacity: 0.7;
        }

        /* Editor content styling */
        .ql-editor {
          color: white !important;
        }

        /* Dropdown menus */
        .ql-picker-options {
          background-color: #333 !important;
          border: 1px solid #555 !important;
        }

        .ql-picker-item {
          color: white !important;
        }

        .ql-picker-item:hover {
          background-color: #555 !important;
        }

        /* Snow theme container */
        .ql-container.ql-snow {
          border-bottom: 1px solid #ccc !important;
          border-left: 1px solid #ccc !important;
          border-right: 1px solid #ccc !important;
        }
      `}</style>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        PaperProps={{
          sx: {
            bgcolor: "#212930",
            borderRadius: 5,
            boxShadow:
              "0 14px 12px 0 rgba(0, 0, 0, 0.2), 0 10px 25px 0 rgba(0, 0, 0, 0.19)",
            border: "1px solid #323d49",
          },
        }}
      >
        <DialogTitle sx={{ color: "white" }}>
          {type === "post" ? "Edit Post" : "Edit Comment"}
        </DialogTitle>

        <DialogContent>

          {type === "post" && (
            <TextField
              fullWidth
              label="Title"
              value={postTitle}
              onChange={(e) => setPostTitle(e.target.value)}
              sx={{
                mb: 3,
                mt: 1,
                "& .MuiInputBase-input": { color: "white" },
                "& .MuiInputLabel-root": { color: "#b0b0b0" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#555" },
                  "&:hover fieldset": { borderColor: "#888" },
                  "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                },
              }}
            />
          )}

          {type === "post" ? (
            <Box
              sx={{
                "& .ql-container": {
                  minHeight: "200px",
                  fontSize: "16px",
                },
                "& .ql-editor": {
                  minHeight: "200px",
                },
              }}
            >
              <ReactQuill
                theme="snow"
                value={value}
                onChange={(content) => setValue(content)}
                modules={quillModules}
                formats={quillFormats}
                placeholder="Edit your post..."
              />
            </Box>
          ) : (
            <TextField
              fullWidth
              multiline
              minRows={3}
              value={value}
              onChange={(e) => setValue(e.target.value)}
              placeholder="Edit your comment..."
              sx={{
                mt: 1,
                "& .MuiInputBase-input": { color: "white" },
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#555" },
                  "&:hover fieldset": { borderColor: "#888" },
                  "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                },
              }}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} sx={{ color: "white" }}>
            Cancel
          </Button>
          <Button
            variant="contained"

            onClick={() => onSave(value, categoryId, postTitle)}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default EditDialog;